/** copy-paste из adaptive */
export var templateParser = function templateParser(str, vars) {
  if (!str) return '';
  if (!vars) return str;
  return str.replace(/{{(\w+)}}/gi, function (full, match) {
    return vars[match];
  });
};